import { render, staticRenderFns } from "./shipinheji.vue?vue&type=template&id=78c11450&scoped=true&"
import script from "./shipinheji.vue?vue&type=script&lang=js&"
export * from "./shipinheji.vue?vue&type=script&lang=js&"
import style0 from "./shipinheji.vue?vue&type=style&index=0&id=78c11450&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c11450",
  null
  
)

export default component.exports